import ResponsibleConsumptionService from 'src/modules/responsibleConsumption/responsibleConsumptionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'RESPONSIBLECONSUMPTION_FORM';

const responsibleConsumptionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: responsibleConsumptionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ResponsibleConsumptionService.find(id);
      }

      dispatch({
        type: responsibleConsumptionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: responsibleConsumptionFormActions.INIT_ERROR,
      });

      navigateTo('/library/responsible-consumption');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: responsibleConsumptionFormActions.CREATE_STARTED,
      });

      await ResponsibleConsumptionService.create(values);

      dispatch({
        type: responsibleConsumptionFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.responsibleConsumption.create.success'));

      navigateTo('/library/responsible-consumption');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: responsibleConsumptionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: responsibleConsumptionFormActions.UPDATE_STARTED,
      });

      await ResponsibleConsumptionService.update(id, values);

      dispatch({
        type: responsibleConsumptionFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.responsibleConsumption.update.success'));

      navigateTo('/library/responsible-consumption');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: responsibleConsumptionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default responsibleConsumptionFormActions;
